export { getConsentNamesForCollectionPoint, ConsentRequester, defaultConsentStatus } from './component.js';
export { usePub, useSub } from './hooks.js';
